const state = {
  sealColor: 'RED',              // 印章颜色
  sealType: '',                  // 印章类型
  sealShowUrl: '',               // 手绘印章
  perAddType: '',                // 个人印章 手绘模板 类型
  infoDateStore: '',             // 用户信息
  templateSearchContent: '',     // 模板搜索内容
  templateCurrentPage: 1,        // 模板list当前页面，
  // 批量签署list
  batchList: [],
  filesUploadOther: ''
};

export default state;



// WEBPACK FOOTER //
// ./src/pages/admin/store/state.js